<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-group element-type-volume element-without-heading" id="vol-1">
<div class="text" id="vol-1-text">
<div class="inline-image inline-image-kind-freestanding inline-image-size-full inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall inline-image-without-caption inline-image-begins-section">
<div class="inline-image-container">
<img alt="The Convent" src="images/convent-candle-copy.jpg"/>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001.vue?b3d28022